import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { ProductAttributeForOption } from '../types'

export const productAvailableAttributeValuesSelector: Selector<ReduxState, ProductAttributeForOption[]> = state =>
  state.products.productAvailableAttributeValues
export default productAvailableAttributeValuesSelector
